import React from 'react'

export function Card({ title, subtitle, children, className = '' }) {
  return (
    <section
      className={`rounded-lg p-4 border border-slate-700 bg-slate-900 ${className}`}
    >
      {title && (
        <header className="mb-3">
          <h3 className="text-sm font-semibold text-slate-100">{title}</h3>
          {subtitle && (
            <p className="mt-0.5 text-xs text-slate-400">{subtitle}</p>
          )}
        </header>
      )}
      {children}
    </section>
  )
}

export function Spinner({ label = 'Loading…' }) {
  return (
    <div className="flex items-center gap-2 text-sm text-slate-400">
      <span
        className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-slate-600 border-t-slate-300"
        aria-hidden="true"
      />
      {label}
    </div>
  )
}

export function ErrorMessage({ error }) {
  if (!error) return null

  return (
    <p
      role="alert"
      className="rounded-md px-3 py-2 text-sm border border-rose-900 bg-rose-950/50 text-rose-300"
    >
      {error.message || String(error)}
    </p>
  )
}

// Non-blocking warning. Used where the app can still be operated but the
// numbers on screen would otherwise be silently meaningless.
export function Notice({ title, children, action }) {
  return (
    <div className="rounded-md px-3 py-2 border border-amber-800 bg-amber-950/40">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-sm font-medium text-amber-200">{title}</p>
          {children && (
            <p className="mt-0.5 text-xs text-amber-300">{children}</p>
          )}
        </div>
        {action}
      </div>
    </div>
  )
}

export function Button({ children, variant = 'primary', className = '', ...props }) {
  const styles = {
    primary:
      'disabled:bg-slate-400 bg-slate-100 text-slate-900 hover:bg-slate-300',
    secondary:
      'border border-slate-600 text-slate-200 hover:bg-slate-800',
  }

  return (
    <button
      className={`rounded-md px-3 py-2 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-60 ${styles[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}

export function Field({ label, ...props }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-medium text-slate-300">
        {label}
      </span>
      <input
        className="w-full rounded-md px-3 py-2 text-sm placeholder:text-slate-400 border focus:border-slate-500 focus:outline-none border-slate-600 bg-slate-900 text-slate-100"
        {...props}
      />
    </label>
  )
}

export function Stat({ label, value, tone = '' }) {
  return (
    <div>
      <div className="text-xs font-medium uppercase tracking-wide text-slate-400">
        {label}
      </div>
      <div className={`mt-0.5 text-xl font-semibold tabular-nums ${tone}`}>{value}</div>
    </div>
  )
}
